<template>
    <div class="list">
        <NavBar></NavBar>
        <van-col span='24' style="text-align:center;font-weight:bold;padding-top:60px;font-size:20px">实名认证成功</van-col>
        <van-cell title="真实姓名:" style="margin-top:30px">
            <template #extra>
                <span>{{fullname}}</span>
            </template>
        </van-cell>
        <van-cell title="身份证号:">
            <template #extra>
                <span>{{Idcard}}</span>
            </template>
        </van-cell>
        <div class="fixedHome">
            <van-col :span="24" class="house_button">
                <van-button type="danger" size="normal" @click="goHome">返回首页</van-button>
            </van-col>
        </div>
        <!-- <van-col span='24' style="text-align:center;font-weight:bold;font-size:18px;margin-top:45px">此页面将在{{seconds}}秒之后关闭...</van-col> -->
    </div>
</template>

<script>
 import { GetQueryString } from '@/assets/js/common.js'
import VueCookie from 'vue-cookie'
export default {
    data(){
        return{
            seconds:'',
            Idcard:'',
            fullname:''
        }
    },
    methods:{
        goHome(){
            // history.go(-1)
            // 在这跳的话判断一下 看看他能不能回退
            // window.location.href='https://open.weixin.qq.com/connect/oauth2/authorize?appid=wxe3a6512ccf114bc4&redirect_uri=http%3a%2f%2fnhzjwxzj.weihai.cn%2findex1.html%23%2f&response_type=code&scope=snsapi_userinfo&state=STATE#wechat_redirect'
            window.location.href='https://open.weixin.qq.com/connect/oauth2/authorize?appid=wxa28bd401be12487d&redirect_uri=http%3a%2f%2fnhzjwxzj.weihai.cn%2findex1.html%23%2f&response_type=code&scope=snsapi_userinfo&state=STATE#wechat_redirect'
            // this.$router.push({
            //     path:"/HouseDetails",
            // })
        },
    },
    created(){
        let BizToken = GetQueryString("BizToken");
        let data = {
            bizToken: BizToken,
            openId:VueCookie.get('openid')
        }
        this.$postQuery('/tencentFaceId/getDetectInfo', data).then((response) => {
            console.log(response);
            if(response.data==200){
                this.fullname = response.obj.realName
                this.Idcard = response.obj.realIdCard
                VueCookie.set('isRealName',response.obj.isRealName)//实名认证成功之后改变isRealName的值为1
                
                // VueCookie.set('fullname',this.fullname) //真实姓名存cookie
                // VueCookie.set('Idcard',this.Idcard)//身份证号存cookie
            }
        })
    }
}
</script>

<style scoped>
.list {
    margin-top: 46px;
}
.fixedHome{
    position: fixed;
    bottom: 0;
    left: 0;
    width: 100%;
}
.house_button{
    padding: 10px;
}
.house_button .van-button,.content_button .van-button{
  width: 100%;
}

</style>